import { getCurrencyCode } from "./getIds.utils";

const formatPrice = (amount?: number, currency?: string): string | null => {
	if (!amount && amount !== 0) {
		return null;
	}

	const currencyCode = currency ?? getCurrencyCode();

	try {
		return new Intl.NumberFormat("en-US", {
			style: "currency",
			currency: currencyCode,
			minimumFractionDigits: 0,
			maximumFractionDigits: 2,
		}).format(amount);
	} catch (error) {
		// Fallback to simple formatting if Intl fails
		const symbolMap: Record<string, string> = {
			NGN: "₦",
			USD: "$",
			EUR: "€",
			GBP: "£",
		};
		const symbol = symbolMap[currencyCode] || currencyCode;
		const formattedAmount = amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
		return `${symbol}${formattedAmount}`;
	}
};

export default formatPrice;
